import { useEffect, useState } from 'react';
import { CHATYME_WINDOW_EVENT } from '../constants/chatymeWindowEvents';
import { LiveChatData } from '../types';
import {
  hydrateAgentMessageLanguageFromStorage,
  resetAgentDefaultLocale
} from '../utils/language';

/** Hydrates agent UI language from chatymeConfig storage; re-renders when config updates. */
export function useAgentMessageLanguage(chatData: LiveChatData | null): void {
  const token = chatData?.token ?? null;
  const [, setLanguageVersion] = useState(0);

  useEffect(() => {
    const refreshLanguage = () => {
      hydrateAgentMessageLanguageFromStorage();
      setLanguageVersion(version => version + 1);
    };

    if (!token) {
      resetAgentDefaultLocale();
      refreshLanguage();
      return;
    }

    refreshLanguage();

    window.addEventListener(CHATYME_WINDOW_EVENT.AGENT_CONFIG_UPDATED, refreshLanguage);
    return () => {
      window.removeEventListener(CHATYME_WINDOW_EVENT.AGENT_CONFIG_UPDATED, refreshLanguage);
    };
  }, [token]);
}
